import { createSlice } from "@reduxjs/toolkit";
import getReferringDoctors from '../../../rtk-apis/appointment/getReferringDoctors'

const initialState = {
  status: "",
  result: [],
  message: "",
  loading: false,
  error: ""
};

const getReferringDoctorsSlice = createSlice({
  name: "getReferringDoctorsData",
  initialState,
  reducers: {
    resetStatus(state: any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReferringDoctors.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getReferringDoctors.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getReferringDoctors.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getReferringDoctorsSlice.reducer;
export const { resetStatus } = getReferringDoctorsSlice.actions;
